import { render, staticRenderFns } from "./FormElementNumberInput.vue?vue&type=template&id=708efafd&"
import script from "./FormElementNumberInput.vue?vue&type=script&lang=js&"
export * from "./FormElementNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports